import styled from '@mui/system/styled';
import { Box, Divider, IconButton } from '@mui/material';

export const ArrowsContainer = styled('div')({
  background: '#616161',
  borderRadius: '3px',
  height: 16,
  width: 20,
  alignItems: 'center',
  justifyContent: 'center',
  display: 'flex',
  svg: { width: 12, height: 12 },
});

export const ImageContainer = styled(Box)({
  position: 'relative',
  padding: '24px',
  height: '100%',
  '.slick-prev': {
    left: 16,
  },
  '.slick-next': {
    right: 16,
  },
  '.slick-prev, .slick-next': {
    zIndex: 1,
    borderRadius: '50%',
    width: 42,
    height: 42,
    background: 'white',
  },
  '.slick-prev:hover, .slick-prev:focus, .slick-next:hover, .slick-next:focus':
    {
      background: 'white',
    },
  '.slick-prev:before, .slick-next:before': {
    color: 'black',
    fontFamily: 'Manrope',
    fontSize: 27,
  },
  '.slick-prev:before': {
    content: '"\\2039"',
  },
  '.slick-next:before': {
    content: '"\\203A"',
  },
  '.slick-slide': {
    height: 550,
  },
});

export const HeaderContent = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: '20px',
  height: 42,
});

export const ButtonsContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: 12,
  height: 42,
  button: {
    color: '#212121',
    height: 42,
    width: 42,
    background: '#EEEEEE',
    '&:hover': {
      background: '#e5e5e5',
    },
  },
});

export const ImageBox = styled('div')({
  justifyContent: 'center',
  display: 'flex !important',
  background: 'lightgray',
  borderRadius: 16,
  overflow: 'hidden',
  img: {
    width: 'auto',
    height: 550,
    transition: 'transform 0.3s ease-in-out',
    borderRadius: 8,
  },
});

// New styled components for elements with inline styles
export const StyledVideoElement = styled('video')({
  maxWidth: '100%',
  maxHeight: '80vh',
  width: '100%',
});

export const FileViewerContainer = styled(Box)({
  height: '70vh',
  width: '100%',
});

export const SopContainer = styled(Box)({
  height: '510px',
  width: '100%',
  overflowY: 'auto',
  padding: '16px',
  backgroundColor: '#ffffff',
  borderRadius: '8px',
  border: '1px solid #E0E0E0',
  boxShadow: '0 0 10px rgba(0,0,0,0.1)',
  margin: '0 auto',
  marginTop: '20px',
  marginBottom: '20px',
  maxWidth: '95%',
  position: 'relative',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: -20,
    width: 20,
    backgroundColor: '#f5f5f5',
    zIndex: -1,
  },
  '&::after': {
    content: '""',
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: -20,
    width: 20,
    backgroundColor: '#f5f5f5',
    zIndex: -1,
  },
});

export const SopContent = styled('div')((props) => ({
  transform: `scale(${props.zoomLevel})`,
  transformOrigin: 'top left',
  transition: 'transform 0.2s ease',
}));

export const ArrowWrapper = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const StyledImage = styled('img')((props) => ({
  transform: `scale(${props.zoomLevel})`,
}));

export const DeleteButton = styled(IconButton)({
  bgcolor: '#FFEBEE',
  color: '#D32F2F',
  '&:hover': { bgcolor: '#FFEBEE' },
});

export const StyledDivider = styled(Divider)({
  border: '1px solid #E0E0E0',
  height: '36px',
});

export const ModalPaperStyles = {
  flexDirection: 'row',
  width: { xs: '100%', md: '1024px' },
  height: 'fit-content',
  maxHeight: '80vh',
};

export const TooltipPopperStyles = {
  '.MuiTooltip-tooltip': {
    marginBottom: '8px !important',
    background: '#212121 !important',
  },
};

export const TooltipPopperStylesSmall = {
  '.MuiTooltip-tooltip': {
    marginBottom: '6px !important',
    background: '#212121 !important',
  },
};
